// @flow
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import type { User, Shift, MultilineDescription, AppScreenType } from '../../typings';
import Avatar from '../Avatar';
import HeaderText from '../Text/HeaderText';
import HeaderSecondText from '../Text/HeaderSecondText';
import getShiftDescription from '../../../timeClock/utils/getShiftDescription';
import cinematicRevealVerticalKeyframes from '../../../keyframes/cinematicRevealVerticalKeyframes';

const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  animation: ${cinematicRevealVerticalKeyframes} 0.4s ease-in-out;
  animation-delay: ${props => (props.shouldDelayAnimation ? '0.7s' : '0s')};
  animation-fill-mode: forwards;
  flex-shrink: 0;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const MainHeaderContainer = styled.div`
  margin-top: 14px;
  margin-bottom: 8px;
`;

const currentDate = new Date();

type Props = {
  user: User | null,
  type: AppScreenType,
  shift: Shift | null,
  shifts: Array<Shift>,
  customLabel: MultilineDescription | null,
  shouldDelayAnimation: boolean
};

export default class UserPanelHeader extends PureComponent<Props> {
  render() {
    const { user, type, shift, shifts, customLabel, shouldDelayAnimation } = this.props;
    const name = user ? user.name : '';
    const { firstLine, secondLine, thirdLine } = getDescription(type, shift, shifts, customLabel);

    return (
      <CenteredContent shouldDelayAnimation={shouldDelayAnimation}>
        {!!user && <Avatar avatar={user.avatar} name={user.name} lastname={user.lastname} />}
        <MainHeaderContainer>
          <HeaderText>
            {getGreeting()}, {name}
          </HeaderText>
        </MainHeaderContainer>
        {!!firstLine && <HeaderSecondText>{firstLine}</HeaderSecondText>}
        {!!secondLine && <HeaderSecondText>{secondLine}</HeaderSecondText>}
        {!!thirdLine && <HeaderSecondText>{thirdLine}</HeaderSecondText>}
      </CenteredContent>
    );
  }
}

function getDescription(type, shift, shifts, customLabel): MultilineDescription {
  if (type === 'shift') {
    return {
      firstLine: getShiftDescription(shift)
    };
  }

  if (type === 'multiShift') {
    return {
      firstLine: `You have ${shifts.length} shifts scheduled`,
      secondLine: 'Select the shift you want to clock into'
    };
  }

  if (customLabel) {
    return customLabel;
  }

  return {
    firstLine: 'You do not have a shift scheduled'
  };
}

function getGreeting() {
  const currentHour = currentDate.getHours();
  if (currentHour >= 12 && currentHour <= 17) {
    return 'Good afternoon';
  }

  if (currentHour >= 17 || currentHour <= 5) {
    return 'Good evening';
  }

  return 'Good morning';
}

UserPanelHeader.propTypes = {
  user: PropTypes.object,
  type: PropTypes.string,
  shift: PropTypes.object,
  shifts: PropTypes.array,
  customLabel: PropTypes.object,
  shouldDelayAnimation: PropTypes.bool
};
